import type { NotifyTranslation } from "./en.notify";

const notifyRu: NotifyTranslation = {
  notifications: {
    title: "Уведомления",
    open: "Уведомления",
    unreadCount: "Непрочитанных: {{count}}",
    markAllRead: "Отметить все как прочитанные",
    seeAll: "Все уведомления",
    empty: "Новых уведомлений нет",
    emptyBody: "Мы сообщим, когда задачи будут готовы для вас, раунды завершатся или изменятся ваши баги.",
    onlyUnread: "Только непрочитанные",
    loadMore: "Загрузить ещё",
    unread: "Не прочитано",
    detail: {
      back: "Все уведомления",
      open: "Открыть",
      notFound: "Такого уведомления нет, или оно не ваше.",
      delivery: "Доставка",
      inApp: "Mixla",
      telegram: "Telegram",
      push: "Пуш в браузере",
      status: { pending: "Отправляется…", sent: "Доставлено", failed: "Ошибка", skipped: "Не отправлено" },
      inAppDelivered: "В ваших уведомлениях",
      skippedTelegram: "Telegram не подключён",
      skippedPush: "Пуш не был включён ни в одном браузере",
    },
    channels: {
      title: "Уведомления",
      intro: "Все уведомления приходят в Mixla. Их также можно получать в Telegram и всплывающими окнами браузера.",
      telegramTitle: "Telegram",
      telegramHint: "Получайте уведомления сообщениями от @{{bot}}.",
      telegramOff: "Telegram не настроен на этом сервере.",
      connect: "Подключить Telegram",
      connectedAs: "Подключено как {{name}}",
      connectedSince: "Подключено {{time}}",
      waiting: "Telegram открыт: нажмите там «Старт». Страница обновится после подключения.",
      openAgain: "Открыть Telegram",
      checkAgain: "Я нажал(а) «Старт»",
      disconnect: "Отключить",
      disconnected: "Telegram отключён",
      connectedToast: "Telegram подключён",
      pushTitle: "Пуш в браузере",
      pushHint: "Всплывающие уведомления в этом браузере, когда Mixla не открыта.",
      pushOn: "Включено для этого браузера.",
      pushBlocked: "Уведомления для этого сайта запрещены. Разрешите их в настройках сайта в браузере и вернитесь.",
      pushUnsupported: "Этот браузер не принимает пуш. На iPhone сначала добавьте Mixla на экран «Домой».",
      pushFailed: "Не удалось включить пуш в этом браузере.",
      pushToggle: "Пуш для этого браузера",
    },
  },
  search: {
    open: "Поиск",
    label: "Поиск по Mixla",
    placeholder: "Задачи, тест-кейсы, баги, проекты…",
    minChars: "Введите хотя бы 2 символа.",
    noResults: "По запросу «{{q}}» ничего не найдено.",
    searching: "Ищем…",
    groups: { project: "Проекты", task: "Задачи", case: "Тест-кейсы", bug: "Баги" },
    quickTitle: "Перейти",
    quick: { inbox: "Входящие", projects: "Проекты", notifications: "Уведомления", profile: "Профиль" },
    hint: "↑↓ — выбор · Enter — открыть · Esc — закрыть",
  },
  gitlabAdmin: {
    title: "GitLab",
    connection: "Подключение",
    notConnected: "Не подключён",
    statusConnected: "Подключён",
    tokenRejected: "Токен отклонён",
    unreachable: "Последняя проверка не прошла",
    connectIntro: "Подключите Mixla к GitLab, и на карточках появятся ветки, merge request, пайплайны и развёртывания.",
    reconnectIntro: "GitLab отключён, его репозитории и связи сохранены. При повторном подключении к тому же хосту вебхуки зарегистрируются снова для используемых репозиториев.",
    baseUrl: "Адрес GitLab",
    token: "Токен доступа",
    tokenHint: "Токен со скоупом api от пользователя с правами Maintainer в репозиториях. Хранится в зашифрованном виде и больше не показывается.",
    connect: "Подключить",
    connected: "GitLab подключён",
    publicUrlMissing: "MIXLA_PUBLIC_URL не задан как https-адрес, поэтому GitLab не сможет отправлять вебхуки в Mixla. Его должен задать тот, кто обслуживает сервер.",
    tokenRejectedBody: "GitLab отклонил токен, поэтому Mixla не может читать данные и обновлять вебхуки. Замените токен, чтобы продолжить. Репозитории и связи не пострадают.",
    lastError: "Последняя проверка не прошла: {{error}}",
    version: "Версия GitLab",
    tokenOwner: "Владелец токена",
    connectedAt: "Подключён",
    lastChecked: "Последняя проверка",
    test: "Проверить подключение",
    testPassed: "GitLab ответил, токен работает",
    replaceToken: "Заменить токен",
    replaceBody: "Вебхуки и репозитории останутся без изменений.",
    tokenReplaced: "Токен заменён",
    rotate: "Сменить секреты вебхуков",
    rotateTitle: "Сменить секреты вебхуков?",
    rotateBody: "Каждый репозиторий получит новый секрет, и Mixla обновит его вебхук через GitLab. Вебхуки, которые не удалось обновить, появятся здесь.",
    rotated: "Секретов вебхуков сменено: {{count}}",
    disconnect: "Отключить",
    disconnectTitle: "Отключить GitLab?",
    disconnectBody: "Токен и все секреты вебхуков будут стёрты, а вебхуки удалены из GitLab. Репозитории, связи и правила останутся, но карточки перестанут обновляться до повторного подключения.",
    disconnected: "GitLab отключён",
    hookFailures: "Не удалось изменить некоторые вебхуки:",
    allowedTitle: "Разрешённые группы и репозитории",
    allowedIntro: "Менеджеры проектов выбирают репозитории из этого списка. Группа включает всё, что в ней находится.",
    allowedEmpty: "Пока ничего не разрешено, поэтому проекты не могут добавлять репозитории.",
    allowedKind: "Тип",
    allowedKinds: { group: "Группа", repo: "Репозиторий" },
    allowedPath: "Путь в GitLab",
    allowedAdded: "Добавлено в список",
    allowedRemove: "Убрать {{path}}",
    allowedRemoved: "Убрано. Репозитории, уже добавленные в проекты, останутся.",
  },
  gitlabProject: {
    notConnectedTitle: "GitLab не подключён",
    notConnectedAsk: "Подключить GitLab может только менеджер платформы. Попросите его об этом, и здесь можно будет выбрать репозитории проекта.",
    notConnectedManager: "Сначала подключите GitLab для всей платформы, и здесь можно будет выбрать репозитории проекта.",
    openAdmin: "Открыть настройки GitLab",
    disconnected: "GitLab отключён, поэтому репозитории не обновляются. Подключить его снова может менеджер платформы.",
    reposTitle: "Репозитории",
    intro: "Ветки и merge request из этих репозиториев связываются с задачами по их ключу. Связывание начинается после добавления репозитория, поэтому более ранняя работа появится, когда GitLab сообщит о новой активности в ней.",
    empty: "Репозиториев пока нет. Добавьте репозиторий, чтобы его работа появилась на карточках проекта.",
    addRepo: "Добавить репозиторий",
    search: "Поиск репозиториев",
    searchPlaceholder: "Название или путь",
    noResults: "Ничего не найдено. Здесь показаны только группы и репозитории, разрешённые менеджером платформы.",
    added: "Добавлен",
    repoAdded: "{{name}} добавлен",
    removeRepo: "Убрать {{name}}",
    removeRepoBody: "Его активность перестанет попадать в этот проект. Уже созданные связи останутся на задачах.",
    repoRemoved: "Репозиторий убран",
    hook: { active: "Вебхук работает", failing: "Сбой вебхука", disabled: "Вебхук отключён", none: "Нет вебхука" },
    hookError: "Ответ GitLab: {{error}}",
    hookDisabledHint: "GitLab отключил этот вебхук после повторяющихся сбоев.",
    registerAgain: "Зарегистрировать вебхук снова",
    hookRegistered: "Вебхук зарегистрирован",
    syncFailing: "Сбой догоняющей синхронизации: {{error}}",
    lastEvent: "Последнее событие {{time}}",
    noEvents: "Событий пока нет",
    lastSynced: "синхронизировано {{time}}",
    rulesTitle: "Правила",
    rulesIntro: "Правила переводят задачи, когда GitLab о чём-то сообщает. Они двигают задачу только вперёд и никогда не выводят её из завершённого или закрытого статуса и из тестирования. Правило для слияния или развёртывания ждёт все подтверждённые merge request задачи. Без включённого правила GitLab не меняет статус задачи.",
    rulesEmpty: "Правил нет. Активность в GitLab не будет двигать задачи.",
    addRule: "Добавить правило",
    editRule: "Изменить правило",
    events: { mr_opened: "MR открыт", mr_merged: "MR влит", deployed: "Развёрнуто в окружение", deployedTo: "Развёрнуто в {{environment}}" },
    statusGone: "Удалённый статус",
    ruleOn: "Включено",
    ruleOff: "Выключено",
    ruleDisabled: "Не работает",
    ruleDisabledHint: "Статус, в который правило переводит задачи, удалён. Измените правило и выберите другой.",
    notSeen: "Ещё не встречалось",
    notSeenHint: "В репозиториях проекта не было развёртываний в это окружение. Название должно совпадать точно.",
    environmentHint: "Выберите окружение из репозиториев проекта или введите название. Оно должно совпадать точно.",
    ruleEvent: "Когда",
    ruleEventFixed: "Это нельзя изменить. Чтобы реагировать на другое событие, добавьте ещё одно правило.",
    ruleEnvironment: "Окружение",
    ruleStatus: "Перевести задачу в",
    pickStatus: "Выберите статус",
    required: "Обязательное поле",
    bugsTitle: "Баги",
    fixOnMerge: "Отмечать связанные баги исправленными при слиянии",
    fixOnMergeHint: "Открытый баг становится исправленным, когда ни один связанный merge request не открыт и хотя бы один влит в основную ветку своего репозитория. Баг без владельца остаётся на месте, а в его активности появляется заметка.",
    withoutKeyTitle: "Влито без ключа",
    withoutKeyIntro: "Merge request'ы, влитые за последние 30 дней, в которых нет ключа вроде {{key}}-12 или {{key}}BUG-12, поэтому они не относятся ни к задаче, ни к багу. Ветки release/* не показываются. Mixla ничего не пишет об этом в GitLab.",
    withoutKeyEmpty: "Здесь пусто. Во всех недавних слияниях есть ключ.",
    ruleStartsOff: "Новые правила выключены. Включите, когда будете готовы.",
    ruleCreated: "Правило добавлено. Оно выключено, пока вы его не включите.",
    ruleSaved: "Правило сохранено",
    removeRule: "Убрать правило",
    removeRuleBody: "«{{rule}}» перестанет двигать задачи. Уже переведённые задачи останутся на месте.",
    ruleRemoved: "Правило убрано",
  },
  channels: {
    title: "Каналы",
    intro: "Публикуйте объявления команды в канал Slack или группу Telegram: новые баги, задачи для тестирования, завершённые раунды.",
    add: "Добавить канал",
    edit: "Редактировать канал",
    empty: "Каналов пока нет.",
    kind: "Тип",
    kinds: { slack: "Slack", telegram: "Telegram" },
    name: "Название",
    namePlaceholder: "например, #payments-qa",
    webhookUrl: "Адрес вебхука Slack",
    webhookHint: "https://hooks.slack.com/services/… — создайте входящий вебхук в Slack.",
    botToken: "Токен бота",
    chatId: "ID чата",
    telegramHelp:
      "1. Создайте бота через @BotFather и скопируйте токен.\n2. Добавьте бота в группу.\n3. Узнайте ID чата группы (например, отправьте сообщение и откройте api.telegram.org/bot<token>/getUpdates); обычно он начинается с -100.",
    replaceCredentials: "Заменить данные доступа",
    credentialsHint: "Оставьте пустым, чтобы сохранить текущие.",
    events: "Сообщать о",
    eventNames: {
      bug_reported: "Новый баг",
      bug_closed: "Баг закрыт",
      task_ready_for_test: "Задача готова к тестированию",
      task_ready_for_retest: "Запрошено повторное тестирование",
      round_finished: "Раунд завершён",
      task_passed: "Задача прошла тестирование",
    },
    minSeverity: "Сообщения о багах",
    severityOptions: { s1: "Только S1", s2: "S1 и S2", s3: "От S1 до S3", s4: "Любая серьёзность" },
    enabled: "Включён",
    disabled: "Приостановлен",
    sendTest: "Тестовое сообщение",
    testSent: "Тестовое сообщение отправлено",
    testFailed: "Тестовое сообщение не отправлено",
    lastOk: "Последнее сообщение доставлено {{time}}",
    lastError: "Последняя отправка не удалась: {{error}}",
    never: "Пока ничего не отправлено",
    remove: "Удалить",
    removeTitle: "Удалить {{name}}?",
    removeBody: "Mixla перестанет писать в этот канал. Сам чат не изменится.",
    created: "Канал добавлен",
    saved: "Канал сохранён",
    removed: "Канал удалён",
    pickEvent: "Выберите хотя бы одно событие.",
    required: "Обязательно",
    managersOnly: "Каналами управляют только менеджеры проекта.",
  },
};

export default notifyRu;
